import {
    NOTIFICATION_START,
    NOTIFICATION_SUCCESS,
    NOTIFICATION_ERROR,
  } from "Constant";
  
  const initialState = {
    loading: false,
    data: [],
    message:""
  };
  
  export default function headerDataReducer(state = { ...initialState }, action) {
    switch (action.type) {
      case NOTIFICATION_START:
        return {
          ...state,
          loading: true,
        };
      case NOTIFICATION_SUCCESS:
        return {
          ...state,
          data: action.payload,
          loading: false,
        };
      case NOTIFICATION_ERROR:
        return {
          ...state,
          loading: false,
          message: action.error.message,
        };
      default:
        return state;
    }
  }
  